import {YMInitializer} from 'react-yandex-metrika';

export const YandexMetrikaProvider = () => {
  if (import.meta.env.DEV) {
    return null;
  }

  return (
    <YMInitializer
      accounts={[48109994]}
      options={{
        clickmap: true,
        defer: true,
        webvisor: true,
      }}
      version="2"
    />
  );
};
